// extracted by mini-css-extract-plugin
export default {"wrapper":"osIRlPn9KBI5wZHL4kGF","passwordRequirements":"Zg3LFHQdjK7i4qPKIVGb"};